import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';

import { GUARD_ACTIONS } from '../TabPanelCondition.constants';
import { formatSensorValue, getCoverPosition, isCoverOpen } from '../TabPanelCondition.utils';
import { CoverIcon } from './CoverIcon';
import { GuardButton } from './GuardButton';

export const CoverSection = ({ transportItem, conditionItem, galileoskyDevice, guardData, guardDisabled, onGuardClick, config }) => {
  const hasDualCover = !!transportItem.trailer_dun_cover;
  const { dun_cover, dun_cover_2 } = conditionItem.data;

  // Форматирование значений
  const dunCoverFormatted = formatSensorValue(dun_cover, config.conditions.dun_cover.default, config.conditions.dun_cover.unit);

  const dunCover2Formatted = hasDualCover
    ? formatSensorValue(dun_cover_2, config.conditions.dun_cover_2.default, config.conditions.dun_cover_2.unit)
    : null;

  // Определение состояния крышек
  const isAnyCoverOpen = isCoverOpen(dun_cover) || (hasDualCover && isCoverOpen(dun_cover_2) && dun_cover_2 !== 65534);

  const coverPosition = hasDualCover ? getCoverPosition(dun_cover, dun_cover_2) : null;

  // Бит guard для крышки
  const guardOutCoverBit = guardData.guardOut[2];
  const guardStatusCoverBit = guardData.guardStatus[2];

  // Проверка возможности управления
  const isControlDisabled =
    !galileoskyDevice || guardData.guardOut[1] === '1' || config.transportDeviceTypes[transportItem.device_type] !== 'galileosky';

  return (
    <Paper variant='outlined'>
      <Typography className='MuiPaper-label' variant='body1'>
        {hasDualCover ? 'Крышки' : 'Крышка'}
      </Typography>

      <Stack
        className='MuiPaperProgress-root'
        sx={{
          ...(hasDualCover && {
            '.MuiPaperProgress-cover': {
              justifyContent: 'space-between!important',
            },
            '.MuiPaperProgress-degrees': {
              position: 'relative!important',
              left: '0!important',
              transform: 'none!important',
              bottom: '0!important',
            },
          }),
        }}>
        {/* Значения датчиков */}
        <div className='MuiPaperProgress-cover'>
          {hasDualCover && (
            <Typography className='MuiPaperProgress-degrees' variant='caption'>
              {galileoskyDevice ? dunCover2Formatted : '-'}
            </Typography>
          )}
          <Typography className='MuiPaperProgress-degrees' variant='caption'>
            {galileoskyDevice ? dunCoverFormatted : '-'}
          </Typography>
        </div>

        {/* Иконка крышки */}
        <div className='MuiPaperProgress-determinate'>
          <CoverIcon
            hasDualCover={hasDualCover}
            isOpen={isAnyCoverOpen}
            position={coverPosition}
            guardStatus={guardStatusCoverBit}
            guardOut={guardData.guardOutNumber}
            guardOutBit={guardOutCoverBit}
            disabled={!galileoskyDevice}
            config={config}
          />
        </div>

        {/* Пустой блок для сенсоров (для выравнивания) */}
        {(Boolean(transportItem.ground_sensor) ||
          Boolean(transportItem.fuel_availability_sensor) ||
          Boolean(transportItem.drain_sensor)) && <div className='MuiPaperProgress-status' />}

        {/* Кнопка управления */}
        <div className='MuiPaperProgress-button'>
          {galileoskyDevice && guardData.guardOutNumber !== config.conditions.guard_out.default ? (
            <GuardButton
              isLocked={guardOutCoverBit === '1'}
              disabled={isControlDisabled || guardDisabled}
              guardDisabled={guardDisabled}
              onToggle={() => onGuardClick(guardOutCoverBit === '1' ? GUARD_ACTIONS.COVER_LOCK : GUARD_ACTIONS.COVER_UNLOCK)}
            />
          ) : (
            <GuardButton disabled />
          )}
        </div>
      </Stack>
    </Paper>
  );
};
